import { render, staticRenderFns } from "./IconRecover.vue?vue&type=template&id=7df8a0b4&functional=true&"
import script from "./IconRecover.vue?vue&type=script&lang=js&"
export * from "./IconRecover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports